const main = "#017f36"

const levelColors = {
    Etapa_roja: "red",
    Etapa_naranja: "orange",
    Etapa_verde: "#017f36",
    Clase_D: "#ffdf00", 
    Clase_C: "brown",
    Clase_B: "purple",
    Clase_A: "blue",
    Profesional: "black"
}

const fontType ={
    title: "Fjalla One",
    subTitle: "Merriweather Sans",
    text: "Readex Pro",
    errorTitle: "Lilita One",
    errorText: "Readex Pro"
}

export {
    main,
    levelColors,
    fontType
}